import React, { useEffect, useState, useContext } from 'react'
import { components, constants } from 'cng-web-lib'
import {
    Box,
    Grid,
    InputAdornment,
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography
} from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { A6TranslationContext } from './contexts/A6TranslationContext'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
    table: {
        '& .MuiTableHead-root': {
            backgroundColor: theme.palette.background.sectionOddBg,
            '& .MuiTableCell-head': {
                borderBottom: 0,
                fontSize: 12,
                fontWeight: 700,
                lineHeight: 1.2,
                textTransform: 'uppercase'
            }
        },
        '& .MuiTableBody-root': {
            '& .MuiTableRow-root': {
                '&:last-child': {
                    '& .MuiTableCell-root': {
                        borderBottom: 0
                    }
                }
            }
        },
        '& .MuiTableCell-root': {
            padding: '8px 16px'
        }
    }
}))

const {
    table: { useFetchCodeMaintenanceLookup },
    button: { CngButton, CngIconButton }
} = components

const { filter: { EQUAL } } = constants

function TaciOcnA6ContainerTable(props) {
    const { data, onAddContainer, onEditContainer, onDeleteContainer } = props
    const { getTranslatedText } = useContext(A6TranslationContext)

    const classes = useStyles()
    const fetchCodeMaintenanceLookup = useFetchCodeMaintenanceLookup()

    const [lookups, setLookups] = useState(null)

    function getLookupValue(name, value) {
        if (!lookups) return value

        return lookups[name] && lookups[name][value] ? lookups[name][value] : value
    }

    useEffect(() => {
        Promise.all([
            // Container Size
            fetchCodeMaintenanceLookup(constants.CodeMaintenanceType.CODE_MASTER, undefined,
                [{ field: 'codeType', operator: EQUAL, value: 'A6_CONTAINER_SIZE' }],
                undefined, 'code'
            ),
            // Container Status
            fetchCodeMaintenanceLookup(constants.CodeMaintenanceType.CODE_MASTER, undefined,
                [{ field: 'codeType', operator: EQUAL, value: 'A6_CONTAINER_STATUS' }],
                undefined, 'code'
            )
        ]).then(([containerSize, containerStatus]) => { setLookups({ containerSize, containerStatus }) })
    }, [])

    return (
        <>
            <Box mb={2}>
                <Grid container spacing={2} justify='flex-end'>
                    {onAddContainer && (
                        <CngButton color='secondary' onClick={onAddContainer} size='medium'
                            startIcon={<FontAwesomeIcon icon={['fal', 'plus-circle']} />}>
                            Add Container
                        </CngButton>
                    )}
                </Grid>
            </Box>

            <TableContainer>
                <Table className={clsx(classes.table, 'new-ui-table-component__table')}>
                    <TableHead>
                        <TableRow>
                            <TableCell>{getTranslatedText('A6', 'containerSize')}</TableCell>
                            <TableCell>{getTranslatedText('A6', 'containerStatus')}</TableCell>
                            <TableCell>{getTranslatedText('A6', 'noOfContainers')}</TableCell>
                            {(onEditContainer || onDeleteContainer) && (<TableCell align='right'>Action</TableCell>)}
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {data.length > 0 ? (
                            data.map((container, index) => (
                                <TableRow key={container._id || container.id || index}>
                                    <TableCell>{getLookupValue('containerSize', container.containerSize)}</TableCell>
                                    <TableCell>{getLookupValue('containerStatus', container.containerStatus)}</TableCell>
                                    <TableCell>{container.noOfContainers}</TableCell>
                                    {(onEditContainer || onDeleteContainer) && (
                                        <TableCell>
                                            <Box display='flex' flexDirection='row' justifyContent='flex-end' style={{ gap: 8 }}>
                                                {onEditContainer && (
                                                    <CngIconButton type='outlined' icon={['fal', 'pen']} onClick={() => onEditContainer(container)} size='small' />
                                                )}
                                                {onDeleteContainer && (
                                                    <CngIconButton type='outlined' icon={['fal', 'trash']} onClick={() => onDeleteContainer(container)} size='small' />
                                                )}
                                            </Box>
                                        </TableCell>
                                    )}
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell align='center' colSpan={3 + (onEditContainer || onDeleteContainer ? 1 : 0)}>
                                    <Typography variant='body2' color='textSecondary'>
                                        No records to display
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}

export default TaciOcnA6ContainerTable
